import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "form-buttons-w text-center" }

import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import useVuelidate from '@vuelidate/core';
import {requiredRule} from "@/shared/validators/validationRules";
import unemployedPrivateCoachingService from "@/api/Unemployed/PrivateCoaching";
import SelectVue from "@/components/SelectVue.vue";
import SaveButton from "@/components/button/SaveButton.vue";
// @ts-ignore
import {getPrivateCoachingByUnemployedDropdown} from '@/shared/dropdowns';


export default /*@__PURE__*/_defineComponent({
  __name: 'AssignCoachingForm',
  props: {
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  unemployedId: {
    type: String,
    required: true,
  },
  documentGroupUuid: {
    type: String,
    required: false,
    default: '',
  },
  selectedCoachingId: {
    type: Number,
    required: false,
    default: null,
  }
},
  emits: ['update:modelValue', 'update:submitForm'],
  setup(__props, { emit: __emit }) {

const {t} = useI18n();
const route = useRoute();
const unemployedId = +(route.params.unemployedId || route.params.id);
const emit = __emit;
const isSubmitting = ref(false);
const isLoaded = ref(false);
const coachingDropdown = ref([])

const props = __props;

const formData = ref<any>({
  documentsGroupId: "",
  coachingId: "",
});

watch(
    () => props.selectedCoachingId,
    (coachingId) => {
      if (coachingId) {
        formData.value.coachingId = coachingId;
      }
    },
    { immediate: true }
);

const rules = computed(() => {
  return {coachingId: requiredRule(t)};
});

const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {

    await unemployedPrivateCoachingService.assignedCoachingToDigitalDocuments(
        props.documentGroupUuid,
        formData.value.coachingId
    );

    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  CloseToast()
  await Promise.all([
    getPrivateCoachingByUnemployedDropdown(coachingDropdown,props.unemployedId)
  ])

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submitForm, ["prevent"]),
    novalidate: ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SelectVue, {
          modelValue: formData.value.coachingId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.coachingId) = $event)),
          options: coachingDropdown.value,
          required: true,
          label: "Maßnahmenn",
          placeholder: "Wählen Sie Maßnahmen",
          validation: _unref(v$).coachingId,
          messages: _unref(v$).coachingId.required.$message
        }, null, 8, ["modelValue", "options", "validation", "messages"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SaveButton, {
        label: _ctx.$t('general.button.save'),
        loading: isSubmitting.value
      }, null, 8, ["label", "loading"])
    ])
  ], 32))
}
}

})